import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xdgzc3qxkf: FaireBrandEntity = {
  token: "b_xdgzc3qxkf",
  type: "brand",
  name: "ITSSY",
  avatarUrl:
    "https://cdn.faire.com/fastly/5b68459ad6e7acc0c91ff6931bfd91478c799624e77bc721f38c87651edfdc4f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7c190801d9cc073f8457f4b7b9407eb14fa3fe75ae4951724c3d977753342f6d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5b68459ad6e7acc0c91ff6931bfd91478c799624e77bc721f38c87651edfdc4f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7c190801d9cc073f8457f4b7b9407eb14fa3fe75ae4951724c3d977753342f6d.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.6,
  reviewCount: 146,
  isInsider: true,
  description:
    "About Itssy\n\nFounded in 2004, Itssy was born from a commitment to provide customers with better-sourced, high-quality products through deep industry knowledge and expertise. Over the years, we have carved out a strong presence in the highly competitive fashion industry by consistently exceeding expectations with our contemporary styles, exceptional quality, and unwavering professionalism.\n\nItssy is renowned for its soft, luxurious fabrics and effortless wearability. Our versatile collections, which include a wide range of fashion tops, basics, and graphic designs, are thoughtfully created to be worn year-round, transcending seasonal trends.\n\nWe like to envision a woman cleaning out her closet, with only her favorite Itssy pieces remaining — because our clothing is built to be timeless, comfortable, and easy to wear.\n\nToday, Itssy is proudly available in department stores, online retailers, and boutiques across the United States. We take great pride not only in the superior quality of our clothing but also in the exceptional customer service we provide to every client.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:43.035Z",
    importedBy: "entity-db-cli",
  },
};
